import create from 'zustand';

interface Store {
    profile: any | null;

    setProfile: (payload: any) => void;
}

/**
 * Store to control process documents form and its sibling components
 */
export const useUserStore = create<Store>((set) => ({
    profile: null,

    setProfile: (payload) =>
        set((state) => {
            return { ...state, profile: payload };
        }),
}));
